
import { config } from "@/utils/config"; //引入公用文件
import { defineComponent, reactive,onMounted, Ref, ref } from "vue";
import {loginApi} from "@/api/login";
import { useRouter } from 'vue-router';
import {useStore} from "vuex";
export default defineComponent({
    setup() {
        let router=useRouter();
        let store=useStore();
        const form = reactive({
            userName: "",
            password: "",
            code: "",
            randomStr: (Math.random() * 100000).toFixed()
        });
        onMounted(() => {
            getImgUrl();
        });
        window.sessionStorage.setItem("sys_title", window.document.title);
        let login = () => {
             loginApi(form).then((res:any)=>{
                 if (res.code === 0) {
                     if(res.data.subUserId){
                         window.sessionStorage.setItem("token", res.data.userId + '_' + res.data.compId + '_' + res.data.subUserId );
                         window.sessionStorage.setItem("subUserId", res.data.subUserId );
                     } else {
                         window.sessionStorage.setItem("token", res.data.userId + '_' + res.data.compId);
                         window.sessionStorage.setItem("compType",res.data.comp.compType);
                         window.sessionStorage.removeItem('subUserId');
                     }
                     window.sessionStorage.setItem("name", res.data.comp.compName);
                     window.sessionStorage.setItem("userId", res.data.userId);
                     window.sessionStorage.setItem("currentUser",  JSON.stringify(res.data));
                     router.push({ path: "/" });
                 } else {
                     form.code='';
                     getImgUrl();
                 }
             });
        };
        // 验证码路径
        // let imgUrl = ref<string>(config.host + "/code?randomStr=" + form.randomStr);
        let imgUrl = ref('');
        let getImgUrl = function () {
            form.randomStr = (Math.random() * 100000).toFixed();
            imgUrl.value = config.host + "/code?randomStr=" + form.randomStr;
            return imgUrl.value;
        };
        return {
            form,
            login,
            getImgUrl,
            imgUrl,
        }
    },
})
